import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      cursor: 'pointer',
      borderRadius: palette.borderRadius.default,
      boxShadow: palette.shadows.boxShadow,
      background: palette.background.box,
      display: 'flex',
      gap: '10px',
      width: 'fit-content',
      alignItems: 'center',
      fontWeight: 600,
      fontSize: '1.25rem',
      padding: '5px 8px 5px 5px',
      userSelect: 'none'
    },
    yes: {
      color: palette.common.green
    },
    no: {
      color: palette.common.primaryRed
    },
    circle: {
      transition: '0.3s ease'
    },
    circleYes: {
      fill: palette.common.green,
      cx: '32px'
    },
    circleNo: {
      fill: palette.common.primaryRed,
      cx: '12px'
    },
    rect: {
      fill: palette.title.primary
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
